export * from "@/ui/components/layout/HorizontalRule/HorizontalRule";
export * from "@/ui/components/layout/HorizontalRule/HorizontalRule.config";
